<template>
  <el-dialog title="案例详情" width="82%" :visible.sync="visible">
    <div class="topSelect">
      <div class="select">
        信息分类：
        <el-select v-model="msg_type">
          <el-option v-for="item in msgType" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>

      <div class="select" v-if="msg_type === '3' || msg_type === '4'">
        参与方编号：
        <el-select v-model="msg_select" placeholder="请选择" @change="sendMsgType">
          <el-option v-for="item in msgSelect" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>

    <div class="mainData">
      <rtasmsg-total v-show="msg_type === '1'"></rtasmsg-total>
      <rtasmsg-env v-show="msg_type === '2'"></rtasmsg-env>
      <rtasmsg-road v-show="msg_type === '3'"></rtasmsg-road>
      <rtasmsg-par v-show="msg_type === '4'"></rtasmsg-par>
      <rtasmsg-sce v-show="msg_type === '5'"></rtasmsg-sce>
      <rtasmsg-obs v-show="msg_type === '6'"></rtasmsg-obs>
      <rtasmsg-dyn v-show="msg_type === '7'"></rtasmsg-dyn>
    </div>

    <div class="bottomButton">
      <el-button type="primary" v-if="change === true">确认修改</el-button>
      <el-button type="info" @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import bus from './bus'
  import rtasmsgTotal from './dialogTotal'
  import rtasmsgRoad from './dialogRoad'
  import rtasmsgEnv from './dialogEnv'
  import rtasmsgPar from './dialogPar'
  import rtasmsgObs from './dialogObs'
  import rtasmsgSce from './dialogSce'
  import rtasmsgDyn from './dialogDyn'

    export default {
      name: "allMsg",
      components:{
        rtasmsgDyn,
        rtasmsgEnv,
        rtasmsgObs,
        rtasmsgPar,
        rtasmsgRoad,
        rtasmsgSce,
        rtasmsgTotal
      },
        data(){
          return{
            /*用以修改按钮确认修改的类型*/
            changeType:'',
            /*控制是否显示确认修改按钮*/
            change:false,
            /*控制开关*/
            visible:false,
            /*信息种类*/
            msg_type: '1',
            /*参与方编号*/
            msg_select: '1',
            msgType: [
              {
                value: '1',
                label: '总体信息'
              }, {
                value: '2',
                label: '环境信息'
              }, {
                value: '3',
                label: '参与方道路信息'
              }, {
                value: '4',
                label: '参与方基本信息'
              },{
                value: '5',
                label: '事故现场几何信息'
              },{
                value: '6',
                label: '静态障碍物几何信息'
              }, {
                value: '7',
                label: '事故方动态信息'
              }
            ],
            msgSelect: [
              {
                value: '1',
                label: '参与方一'
              }, {
                value: '2',
                label: '参与方二'
              }
            ],
            /*页面总数据*/
            allData:{},
            /*总体数据*/
            total:{},
            /*环境信息*/
            env:{},
            /*道路信息*/
            road:[],
            /*参与方信息*/
            par:[],
            /*事故现场几何信息*/
            sce:[],
            /*障碍物信息*/
            obs:[],
            /*动态信息*/
            dyn:[]
          }
        },
        methods:{
        /*发送参与方编号*/
          sendMsgType(){
            bus.$emit("parType",this.msg_select);
          },
          /*发送对应数据*/
          sendData(){
            /**/
            this.env = this.allData.environment;
            bus.$emit("env",this.env);
            this.road = this.allData.roadList;
            bus.$emit("road",this.road);
            this.par.carList = this.allData.carList;
            this.par.personList = this.allData.personList;
            this.par.twoWheelVehicleList = this.allData.twoWheelVehicleList;
            bus.$emit("par",this.par);
            this.sce = this.allData.sceneList;
            bus.$emit("sce",this.sce);
            this.obs = this.allData.obstacleList;
            bus.$emit("obs",this.obs);
            this.dyn = this.allData.dynamicList;
            bus.$emit("dyn",this.dyn);
            for(let i in this.allData){
              if(i !== 'environment' && i !== 'roadList' && i !== 'carList' && i !== 'personList' && i !== 'twoWheelVehicleList' && i !== 'sceneList' && i !== 'obstacleList' && i !== 'dynamicList' && i !== 'moveInformationList' && i !== 'moveObstaclesList' ){
                  for (let key of Object.keys(this.allData)) {
                    if(key === i){
                      this.total[key] = this.allData[key];
                    }
                  }
              }
            }
            bus.$emit("total",this.total);
            bus.$emit("caseNumber",this.allData.caseNumber);
          }
        },
        created(){
        /*打开详情页面*/
          bus.$on("visible",()=>{
            this.visible = true;
          });
          bus.$on("allData",msg=>{
            this.allData = msg;
            this.sendData();
          });
          /*确认修改的参与方信息的类型*/
          bus.$on("car",()=>{
            this.changeType = 1;
          });
          bus.$on("twoWheel",()=>{
            this.changeType = 2;
          });
          bus.$on("person",()=>{
            this.changeType = 3;
          });
          if(this.change === true){
            bus.$emit("change")
          }
        }
    }
</script>

<style scoped>
  .topSelect{
    width: 60%;
    height: 50px;
    display: flex;
  }
  .select{
    width: 45%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mainData{
    margin-top: 15px;
    width: 100%;
    height: calc(100% - 115px);
    overflow-y: scroll;
  }
  .bottomButton{
    width: 20%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-left: 80%;
  }
</style>
<style>
  .el-dialog{
    min-width: 1200px !important;
    height: 70% !important;
  }
  .el-dialog__body{
    padding: 0 !important;
    height: calc(100% - 54px);
  }
</style>




// WEBPACK FOOTER //
// src/exportData/allMsg.vue